import React from 'react';
import { motion } from 'framer-motion';
import { Layers, Map, CheckCircle2 } from 'lucide-react';
export function ProductReveal() {
  return <section className="w-full px-6 py-16 bg-cream overflow-hidden" data-id="element-114">
      <div className="max-w-reading mx-auto" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-116">
          <h2 className="text-4xl md:text-5xl text-brown mb-4" data-id="element-117">
            Presento: Bebé Sin Derrumbe
          </h2>
          <p className="text-xl text-brown/80 font-light" data-id="element-118">
            Kit de 14 días para bajar la carga mental{' '}
            <br className="hidden md:block" data-id="element-119" />
            (sin apps, sin "hablarlo mil veces")
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative mb-16" data-id="element-120">
          <div className="absolute inset-0 bg-ochre/10 blur-3xl rounded-full transform scale-75 z-0" data-id="element-121"></div>
          <img src="https://cdn.magicpatterns.com/uploads/7b7PH67A5iXJoSXfgoE7Ez/mockup_de_bebe_sin_derumbe.png" alt="Bebé Sin Derrumbe Kit Mockup" className="relative z-10 w-full max-w-md mx-auto rounded-lg shadow-2xl rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-122" />
        </motion.div>

        <div className="space-y-12" data-id="element-123">
          <p className="text-xl text-brown text-center leading-relaxed" data-id="element-124">
            Este kit te lleva por un plan simple para transformar{' '}
            <br className="hidden md:block" data-id="element-125" />
            <span className="italic" data-id="element-126">"ayúdame"</span> en{' '}
            <span className="font-bold text-ochre" data-id="element-127">"esto es tuyo"</span>.
          </p>

          <div className="grid gap-8 md:grid-cols-2" data-id="element-128">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-stone-100" data-id="element-129">
              <div className="w-12 h-12 bg-ochre/20 rounded-full flex items-center justify-center mb-4 text-ochre" data-id="element-130">
                <Map size={24} data-id="element-131" />
              </div>
              <h3 className="text-xl font-serif text-brown mb-2" data-id="element-132">
                1. Mapa de Carga Mental
              </h3>
              <p className="text-brown/80" data-id="element-133">
                Para hacer visible lo que hoy estás cargando sola.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-stone-100" data-id="element-134">
              <div className="w-12 h-12 bg-ochre/20 rounded-full flex items-center justify-center mb-4 text-ochre" data-id="element-135">
                <Layers size={24} data-id="element-136" />
              </div>
              <h3 className="text-xl font-serif text-brown mb-2" data-id="element-137">
                2. Tarjetas de Propiedad
              </h3>
              <p className="text-brown/80 mb-4" data-id="element-138">
                Cada tarea queda asignada con un dueño/a, incluyendo las 4
                capas:
              </p>
              <div className="flex flex-wrap gap-2 text-xs font-medium uppercase tracking-wider text-brown/70" data-id="element-139">
                <span className="bg-cream px-2 py-1 rounded border border-stone-200" data-id="element-140">
                  Pensar
                </span>
                <span data-id="element-141">→</span>
                <span className="bg-cream px-2 py-1 rounded border border-stone-200" data-id="element-142">
                  Planear
                </span>
                <span data-id="element-143">→</span>
                <span className="bg-cream px-2 py-1 rounded border border-stone-200" data-id="element-144">
                  Hacer
                </span>
                <span data-id="element-145">→</span>
                <span className="bg-cream px-2 py-1 rounded border border-stone-200" data-id="element-146">
                  Cerrar
                </span>
              </div>
            </div>
          </div>

          <div className="bg-brown/5 p-8 rounded-2xl mt-12" data-id="element-147">
            <h3 className="text-2xl font-serif text-brown mb-6 text-center" data-id="element-148">
              Qué cambia en 14 días
            </h3>
            <ul className="space-y-4" data-id="element-149">
              {['Dejas de perseguir y recordar (porque hay propiedad)', 'Se reduce el resentimiento (porque ya no estás sola en la cabeza)', 'Disminuyen discusiones repetidas (porque hay acuerdos escritos)', 'Recuperas aire mental aunque el bebé siga siendo bebé'].map((item, i) => <li key={i} className="flex items-start gap-3 text-brown/90" data-id="element-150">
                  <CheckCircle2 className="w-5 h-5 text-ochre flex-shrink-0 mt-1" data-id="element-151" />
                  <span data-id="element-152">{item}</span>
                </li>)}
            </ul>
          </div>

          <p className="text-center text-lg text-brown/70 italic" data-id="element-153">
            "No te prometo 'vida perfecta'. Te prometo algo más útil: <br data-id="element-154" />
            <span className="font-serif text-brown not-italic text-xl" data-id="element-155">
              estructura en el caos real."
            </span>
          </p>
        </div>
      </div>
    </section>;
}